import React, { useEffect, useRef } from 'react';

// Generic Embed Section (iframes, scripts, etc.)
const EmbedSection = ({ data }) => {
  const { embed_code, heading, max_width = '100%', padding = true } = data || {};
  const containerRef = useRef(null);
  
  useEffect(() => {
    if (!embed_code || !containerRef.current) return;
    
    // If embed contains script tags, we need to execute them
    const container = containerRef.current;
    container.innerHTML = embed_code;
    
    // Find and execute any script tags
    const scripts = container.querySelectorAll('script');
    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script');
      
      // Copy attributes
      Array.from(oldScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      
      // Copy inline script content
      if (oldScript.textContent) {
        newScript.textContent = oldScript.textContent;
      }
      
      // Replace old script with new one to execute it
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }, [embed_code]);
  
  if (!embed_code) {
    return null;
  }
  
  return (
    <section className={padding ? 'py-16 px-4' : ''}>
      <div className="max-w-6xl mx-auto" style={{ maxWidth: max_width }}>
        {heading && (
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            {heading}
          </h2>
        )}
        <div 
          ref={containerRef}
          className="embed-container"
        />
      </div>
    </section>
  );
};

export default EmbedSection;
